import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
// import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./languages/locales/en_US.json";
import translationID from "./languages/locales/id_ID.json";

const fallbackLng = ["en"];
const availableLanguages = ["en", "id"];

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,

    detection: {
      checkWhitelist: true,
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
